// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__DeDy_","auto":"Footer_auto__dKoUf","socialIcon":"Footer_socialIcon__taZu8"};